import { IButtonStyles, Theme } from "@fluentui/react";

export const labelStyles = {
  root: {
    fontFamily: "Segoe UI",
    fontSize: "0.875rem",
    lineHeight: "1.25rem"
  }
};

export const buttonStyles = (_theme: Theme): Partial<IButtonStyles> => ({
  root: {
    backgroundColor: _theme.palette.neutralLighterAlt
  }
});
